import {useState } from 'react'
import {useAuthContext} from '../../../hooks/useAuthContext.js'
import LoginTile from '../../Components/LoginTile/LoginTile.js';

const Login = () => {
    const {signIn} = useAuthContext()
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("")
    const [error, setError] = useState("")
    const [data, setData] = useState("")

    const handleSubmit = async (event, email, password) => {
        event.preventDefault()
        const userData = await signIn(
            email,
            password
        )
        console.log(userData)
        
        if (userData.error){
            setError(userData.error);
        } else {
            setData(userData.data);
        }
    }

    return (
        <LoginTile
            type='login'
            handleSubmit={handleSubmit}
        />
    )

};

export default Login;